import React, { Component } from 'react';
import Inherit from './core/inherit';
import AppController from './app.controller';
import { ErrorScreen } from './elements';
import { ClockoutRouter, OnboardingSplashScreen } from '@clockout-dev/clockout-components';
import '@clockout-dev/clockout-components/style.css';
import withSearchParams from './core/withProps';

class App extends Inherit(AppController, Component) {
    state = { loading: true, error: false };
    render() {
        const { loading, error } = this.state;

        if (loading && !error) {
            return <OnboardingSplashScreen 
                primaryColor='#137D9E'
                secondBackgroundColor='#F5FAFF'
            />;
        }

        if (error) {
            return <ErrorScreen />;
        }

        return <ClockoutRouter />;
    }
}

export default withSearchParams(App);
